import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-renew-request',
  templateUrl: './renew-request.component.html',
  styleUrls: ['./renew-request.component.scss']
})
export class RenewRequestComponent implements OnInit {
  constructor(
    private _dialogRef: MatDialogRef<RenewRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data) { }
  ngOnInit(): void {
  }
  dialogClose(): void {
    // this._dialogRef.close();
    document.getElementsByClassName('animate__animated')[0].classList.remove('animate__fadeInDown');
    document.getElementsByClassName('animate__animated')[0].classList.add('animate__fadeOutUp');
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }
}
